// extracted by mini-css-extract-plugin
export default {"modalWrapper":"on-leaving-alert_modalWrapper__uXFJI","modalSection":"on-leaving-alert_modalSection__gViak","buttonsWrapper":"on-leaving-alert_buttonsWrapper__xBwjh"};